module.exports = __webpack_public_path__ + "img/five3Red.dd898161.jpg";